// @flow
import {PINNED_PROPERTY_SET_LABEL} from '../actions/pinnedProperty';
import type {Action} from '../actions/pinnedProperty';

export type State = {
    label?: string
};

const initialState: State = {
    label: ''
};

export default function reducer(
    state: State = initialState,
    action: Action
): State {
    if (action.type === PINNED_PROPERTY_SET_LABEL) {
        return {
            ...state,
            label: action.payload.label
        };
    }
    return state;
}
